<template>
  <div class="header__search" :class="{'header__search--open': openSearch}">
    <form :action="action" method="POST">
      <div class="search-form" v-on-clickaway="away">
        <input type="hidden" name="_token" :value="token" id="csrf-token">
        <input v-mask="'XXXXXXXXXX'" name="search" type="text" placeholder="Buscar..." ref="search"
          class="browser-default search-form__field" :class="{'search-form__field--open': openSearch}">
        <div class="search-form__button" @click="toggleSearch">
          <i class="fa" :class="openSearch ? 'fa-close' : 'fa-search'" aria-hidden="true"></i>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  props : {
    token : {
      type : String,
      required : true
    }
  },
  mixins: [ clickaway ],
  data () {
    return {
      openSearch: false,
      action : url + '/search'
    }
  },
  methods: {
    toggleSearch() {
      this.openSearch = !this.openSearch
      this.$nextTick(() => {
        const $inputSearch = this.$refs.search
        $inputSearch.focus()
        $inputSearch.value = ''
      })
    },
    away () {
      if (this.openSearch) {
        this.openSearch = false;
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/layout/menu/Search.vue